<template>
  <div class="caas">
    <div class="caas-header" id="header">
      <img :src="header" ref="img1" />
    </div>

    <div class="caas-introduce">
      <div class="in-box">
        <div class="in-icon">
          <div class="in-img">
            <img src="../assets/web/全球覆盖.svg" />
          </div>
          <div class="icon-title">{{$t('Cass.ico1')}}</div>
        </div>
        <div class="in-icon">
          <div class="in-img">
            <img src="../assets/web/芯片.svg" />
          </div>
          <div class="icon-title">{{$t('Cass.ico2')}}</div>
        </div>
        <div class="in-icon">
          <div class="in-img">
            <img src="../assets/web/结构.svg" />
          </div>
          <div class="icon-title">{{$t('Cass.ico3')}}</div>
        </div>
        <div class="in-icon">
          <div class="in-img">
            <img src="../assets/web/开放 .svg" />
          </div>
          <div class="icon-title">{{$t('Cass.ico4')}}</div>
        </div>
      </div>
      <Divider />
      <p class="in-content">
        {{$t('Cass.intro')}}
        <router-link to="/Resources">
          <span>{{$t('learnMore')}}&nbsp;&nbsp;></span>
        </router-link>
      </p>
    </div>

    <div class="caas-network" id="Global">
      <p class="net-title">{{$t('Cass.global.title')}}</p>
      <div class="flex-box">
        <div class="img-box">
          <img src="../assets/web/平台1.png" />
          <p class="img-title">{{$t('Cass.tra')}}</p>
          <p class="img-content">{{$t('Cass.global.text1')}}</p>
        </div>
        <div class="img-box">
          <img src="../assets/web/平台2.png" />
          <p class="img-title">{{$t('Cass.tea')}}</p>
          <p class="img-content">
            {{$t('Cass.global.content1')}}
            <router-link target="_blank" to="coverage">
              <span style="cursor:pointer;">{{$t('Cass.global.check')}}</span>
            </router-link>
          </p>
        </div>
      </div>
    </div>

    <div style="background:rgba(249, 249, 249, 1)">
      <div class="embed" id="Embedded">
        <p class="em-title">{{$t('Cass.em.title')}}</p>

        <Row class="flex-box">
          <Col span="5">{{$t('Cass.OS')}}</Col>
          <Col span="5">Android</Col>
          <Col span="5">Linux</Col>
          <Col span="5">RTOS</Col>
          <Col span="4">...</Col>
        </Row>
        <Row class="flex-box">
          <Col span="5">{{$t('Cass.medium')}}</Col>
          <Col span="5">TEE</Col>
          <Col span="5">eUICC</Col>
          <Col span="5">iUICC</Col>
          <Col span="4">...</Col>
        </Row>
        <Row class="flex-box">
          <Col span="5">{{$t('Cass.Chip')}}</Col>
          <Col span="5">Qualcomm</Col>
          <Col span="5">MediaTek</Col>
          <Col span="5">Samsung</Col>
          <Col span="4">...</Col>
        </Row>
        <div class="content-box">
          <div class="con-box">
            <p class="con-title">{{$t('Cass.tra')}}</p>
            <p class="con-content beforeLine">{{$t('Cass.em.text1')}}</p>
            <p class="con-content beforeLine">{{$t('Cass.em.text2')}}</p>
            <p class="con-content beforeLine">{{$t('Cass.em.text3')}}</p>
          </div>
          <div class="con-box">
            <p class="con-title">{{$t('Cass.tea')}}</p>
            <p class="con-content">{{$t('Cass.em.content1')}}</p>
            <p class="con-content beforeLine">{{$t('Cass.em.content2')}}</p>
            <p class="con-content beforeLine">{{$t('Cass.em.content3')}}</p>
            <p class="con-content beforeLine">{{$t('Cass.em.content4')}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="embed" id="Open">
      <p class="em-title">{{$t('Cass.open.title')}}</p>
      <div class="content-box">
        <div class="con-box">
          <img src="../assets/web/traditional-approach.png" />
          <p class="con-title">{{$t('Cass.tra')}}</p>
          <p class="con-content beforeLine">{{$t('Cass.open.text1')}}</p>
          <p class="con-content beforeLine">{{$t('Cass.open.text2')}}</p>
        </div>
        <div class="con-box">
          <img src="../assets/web/With Redtea_.png" />
          <p class="con-title">{{$t('Cass.tea')}}</p>
          <p class="con-content">{{$t('Cass.open.content1')}}</p>
          <p class="con-content beforeLine">{{$t('Cass.open.content2')}}</p>
          <p class="con-content beforeLine">{{$t('Cass.open.content3')}}</p>
        </div>
      </div>
    </div>

    <div style="background:rgba(249, 249, 249, 1);">
      <div class="smart" id="Smart">
        <p class="smart-title">{{$t('Cass.smart.title')}}</p>
        <img src="../assets/web/Smart Connectivity_ We've been working on more cool stuffs.png" />
        <p class="smart-content">{{$t('Cass.smart.des')}}</p>
      </div>
    </div>

    <Modal v-model="modal" footer-hide width="800" :title="$t('coverage.title')">
      <div class="modal-title">
        <Icon type="ios-disc" color="#CF2A2A" />
        &nbsp;&nbsp;{{$t('coverage.title1')}}
      </div>
      <div class="modal-content">{{$t('coverage.text1')}}</div>
      <div class="modal-title">
        <Icon type="ios-disc" color="#CF2A2A" />
        &nbsp;&nbsp;{{$t('coverage.title2')}}
      </div>
      <div class="modal-content">{{$t('coverage.text2')}}</div>
      <div class="modal-title">
        <Icon type="ios-disc" color="#CF2A2A" />
        &nbsp;&nbsp;{{$t('coverage.title3')}}
      </div>
      <div class="modal-content">{{$t('coverage.text3')}}</div>
      <div class="modal-title">
        <Icon type="ios-disc" color="#CF2A2A" />
        &nbsp;&nbsp;{{$t('coverage.title4')}}
      </div>
      <div class="modal-content">{{$t('coverage.text4')}}</div>
      <div class="modal-title">
        <Icon type="ios-disc" color="#CF2A2A" />
        &nbsp;&nbsp;{{$t('coverage.title5')}}
      </div>
      <div class="modal-content">{{$t('coverage.text5')}}</div>
      <div class="modal-title">
        <Icon type="ios-disc" color="#CF2A2A" />
        &nbsp;&nbsp;{{$t('coverage.title6')}}
      </div>
      <div class="modal-content">{{$t('coverage.text6')}}</div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'caas-web',
  data() {
    return {
      modal: false
    }
  },
  computed: {
    header() {
      return this.$store.state.img1
    }
  }
}
</script>
<style lang="less" scoped>
.caas {
  .caas-header {
    display: flex;
    justify-content: center;
    background: rgba(249, 249, 249, 1);
    img {
      display: block;
      width: 11.8rem;
      height: 100%;
    }
  }
  .caas-introduce {
    width: 11.8rem;
    margin: auto;
    padding: 1.2rem 0;
    .in-box {
      display: flex;
      justify-content: space-between;
      padding: 0 0.4rem;
      .in-icon {
        display: flex;
        justify-content: center;
        .in-img {
          display: flex;
          align-items: center;
          margin-right: 0.15rem;
          img {
            width: 0.46rem;
          }
        }
        .icon-title {
          color: rgba(32, 49, 82, 1);
          font-family: 'Poppins-Light';
          font-size: 16px;
          line-height: 46px;
        }
      }
    }
    .in-content {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Light';
      font-size: 14px;
      width: 88%;
      text-align: left;
      margin: auto;
      span {
        color: rgba(207, 42, 42, 1);
        text-decoration: underline;
      }
    }
  }
  .caas-network {
    width: 11.8rem;
    margin: auto;
    padding-bottom: 1.2rem;
    .net-title {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Regular';
      font-size: 20px;
    }
    .flex-box {
      display: flex;
      justify-content: space-between;
      .img-box {
        width: 5.5rem;
        img {
          width: 5.5rem;
        }
        .img-title {
          color: rgba(32, 49, 82, 1);
          font-family: 'Poppins-Regular';
          font-size: 16px;
          text-align: left;
          margin: 0.2rem 0;
        }
        .img-content {
          color: rgba(32, 49, 82, 1);
          font-family: 'Poppins-Light';
          font-size: 14px;
          text-align: left;
          span {
            color: rgba(207, 42, 42, 1);
            text-decoration: underline;
          }
        }
      }
    }
  }
  .embed {
    width: 11.8rem;
    margin: auto;
    padding: 1.2rem 0;
    .em-title {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Regular';
      font-size: 20px;
      margin-bottom: 0.3rem;
    }
    .flex-box {
      width: 7.83rem;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0.02rem 0.4rem 0px rgba(0, 0, 0, 0.05);
      border-radius: 0.1rem;
      display: flex;
      justify-content: space-around;
      padding: 0.19rem 0;
      margin: 0 0 0.1rem 2.5rem;
      span {
        color: rgba(32, 49, 82, 1);
        font-family: 'Poppins-Regular';
        font-size: 16px;
      }
    }
    .content-box {
      display: flex;
      justify-content: space-between;
      margin-top: 0.3rem;
    }
    .con-box {
      width: 5.5rem;
      .con-title {
        color: rgba(32, 49, 82, 1);
        font-family: 'Poppins-Regular';
        font-size: 16px;
        text-align: left;
        margin-bottom: 0.2rem;
        margin-top: 0.2rem;
      }
      .con-content {
        color: rgba(32, 49, 82, 1);
        font-family: 'Poppins-Light';
        font-size: 14px;
        text-align: left;
      }
      img {
        margin-bottom: 0.1rem;
      }
    }
  }
  .smart {
    width: 11.8rem;
    padding: 1.2rem 0;
    margin: auto;
    .smart-title {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Regular';
      font-size: 20px;
    }
    .smart-content {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Light';
      font-size: 14px;
      text-align: left;
    }
    img {
      margin: 0.2rem 0 0.3rem 0;
    }
  }
}
</style>
<style lang="less">
.modal-title {
  font-family: 'Poppins-Bold';
  font-size: 14px;
  margin-bottom: 0.1rem;
}
.modal-content {
  font-family: 'Poppins-Light';
  font-size: 12px;
  margin-bottom: 0.4rem;
}
</style>
